import { render, staticRenderFns } from "./FilterGroups.vue?vue&type=template&id=5ca58d27"
import script from "./FilterGroups.vue?vue&type=script&lang=js"
export * from "./FilterGroups.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports